import {
  COMPANY_ADDRESS,
  COMPANY_BRAND_NAME,
  COMPANY_EMAIL,
  COMPANY_GEO,
  COMPANY_LEGAL_NAME,
  COMPANY_PHONE_DISPLAY,
  COMPANY_PHONE_E164,
  COMPANY_REQUISITES_URL,
  COMPANY_SAME_AS,
  COMPANY_SITE_URL,
  COMPANY_YANDEX_MAP_URL,
} from "@/lib/brand/organization";

export type OrganizationProfile = {
  legalName: string;
  brandName: string;
  email: string;
  phoneE164: string;
  phoneDisplay: string;
  addressCountry: string;
  addressLocality: string;
  addressStreet: string;
  addressFormatted: string;
  geoLat: number;
  geoLon: number;
  yandexMapUrl: string;
  requisitesUrl: string;
  operatorSiteUrl: string;
  sameAs: string[];
};

export const DEFAULT_ORGANIZATION_PROFILE: OrganizationProfile = {
  legalName: COMPANY_LEGAL_NAME,
  brandName: COMPANY_BRAND_NAME,
  email: COMPANY_EMAIL,
  phoneE164: COMPANY_PHONE_E164,
  phoneDisplay: COMPANY_PHONE_DISPLAY,
  addressCountry: COMPANY_ADDRESS.country,
  addressLocality: COMPANY_ADDRESS.locality,
  addressStreet: COMPANY_ADDRESS.streetAddress,
  addressFormatted: COMPANY_ADDRESS.formatted,
  geoLat: COMPANY_GEO.lat,
  geoLon: COMPANY_GEO.lon,
  yandexMapUrl: COMPANY_YANDEX_MAP_URL,
  requisitesUrl: COMPANY_REQUISITES_URL,
  operatorSiteUrl: COMPANY_SITE_URL,
  sameAs: [...COMPANY_SAME_AS],
};

export function parseOrganizationProfile(
  raw: string | null | undefined,
): OrganizationProfile | null {
  if (!raw?.trim()) return null;
  try {
    const data = JSON.parse(raw) as Partial<OrganizationProfile>;
    if (!data || typeof data !== "object") return null;
    return {
      ...DEFAULT_ORGANIZATION_PROFILE,
      ...data,
      sameAs: Array.isArray(data.sameAs)
        ? data.sameAs.filter((v): v is string => typeof v === "string" && Boolean(v.trim()))
        : DEFAULT_ORGANIZATION_PROFILE.sameAs,
      geoLat:
        typeof data.geoLat === "number" && Number.isFinite(data.geoLat)
          ? data.geoLat
          : DEFAULT_ORGANIZATION_PROFILE.geoLat,
      geoLon:
        typeof data.geoLon === "number" && Number.isFinite(data.geoLon)
          ? data.geoLon
          : DEFAULT_ORGANIZATION_PROFILE.geoLon,
    };
  } catch {
    return null;
  }
}
